export default __webpack_public_path__ + "static/media/gnd_kr_star_b1.085e2d4a.mp3";